import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useThemeMode } from '../../ThemeContext';
import { APP_URLS } from '../../helpers/url_helper';
import StandaloneTopbar from '../../components/StandaloneTopbar';
import './StripePayment.css';

// Import assets (using existing SVG that looks like cancel/error)
import prohibitedIcon from '../../assets/Prohibited.svg';

function StandalonePaymentCancel() {
  const { mode } = useThemeMode();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [sessionData, setSessionData] = useState(null);

  // Initialize theme on component mount
  useEffect(() => {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(mode === 'dark' ? 'dark-mode' : 'light-mode');
  }, [mode]);

  // Get session details from URL params
  useEffect(() => {
    const planName = searchParams.get('plan');
    const billingCycle = searchParams.get('billing');
    
    setSessionData({
      planName: planName || 'Selected Plan',
      billingCycle: billingCycle || 'monthly'
    });
  }, [searchParams]);

  const handleTryAgain = () => {
    navigate('/newSubscription');
  };

  const handleGoToDashboard = () => {
    navigate(APP_URLS.DASHBOARD);
  };

  return (
    <div className="standalone-page">
      <StandaloneTopbar />
      <div className="payment-result-page" style={{ marginTop: '60px' }}>
        <div className="payment-result-container">
          {/* Cancel Icon */}
          <div className="result-icon cancel">
            <img src={prohibitedIcon} alt="Payment Cancelled" className="icon" />
          </div>

          {/* Cancel Message */}
          <div className="result-content">
            <h1 className="result-title">Payment Cancelled</h1>
            <p className="result-message">
              Your payment was cancelled. No charges have been made to your account.
            </p>

            {/* Session Details */}
            {sessionData && (
              <div className="session-details">
                <h3>Plan Details</h3>
                <div className="detail-item">
                  <span className="detail-label">Plan:</span>
                  <span className="detail-value">{sessionData.planName}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Billing Cycle:</span>
                  <span className="detail-value capitalize">{sessionData.billingCycle}</span>
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div className="result-actions">
              <Button
                variant="outline"
                onClick={handleGoToDashboard}
                className="action-button"
              >
                Go to Dashboard
              </Button>
              <Button
                variant="primary"
                onClick={handleTryAgain}
                className="action-button primary"
              >
                Try Again
              </Button>
            </div>

            {/* Additional Info */}
            <div className="result-info">
              <p>
                <strong>Need help?</strong> If you encountered any issues during payment, 
                please contact our support team or try again with a different payment method.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StandalonePaymentCancel;
